import React from 'react';
import {SvgIcon} from '@material-ui/core';

export default function TwitterIcon() {
    return (
        <SvgIcon width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" fillRule="evenodd">
                <g>
                    <g>
                        <g>
                            <path fill="#FFF" fillOpacity=".2" d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm2.692 6c-1.586 0-2.87 1.356-2.87 3.029 0 .238.023.469.072.69-2.386-.127-4.502-1.331-5.92-3.165-.247.449-.388.969-.388 1.523 0 1.05.507 1.978 1.278 2.522-.471-.015-.914-.153-1.302-.378v.037c0 1.468.99 2.693 2.305 2.97-.242.071-.495.107-.758.107-.184 0-.365-.019-.54-.054.365 1.203 1.426 2.08 2.684 2.103-.984.813-2.222 1.297-3.568 1.297-.231 0-.46-.013-.685-.042C6.271 17.5 7.78 18 9.403 18c5.284 0 8.171-4.616 8.171-8.62 0-.13-.001-.262-.007-.39.561-.428 1.05-.962 1.433-1.57-.515.241-1.07.404-1.65.477.594-.374 1.05-.968 1.263-1.675-.556.347-1.17.599-1.824.735-.523-.59-1.27-.957-2.097-.957z" transform="translate(-1381 -6141) translate(-1 6036) translate(1382 105)" />
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>

    );
}



// WEBPACK FOOTER //
// ./src/components/controls/icons/TwitterIcon.jsx